"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_PAYLOAD_SIZE = exports.IDEAL_PAYLOAD_SIZE = void 0;
const IDEAL_PAYLOAD_SIZE = exports.IDEAL_PAYLOAD_SIZE = 64000;
const MAX_PAYLOAD_SIZE = exports.MAX_PAYLOAD_SIZE = 1000000;